import React, { useEffect, useState } from "react";
import { MoreVertical } from "lucide-react";
import { LuSearch } from "react-icons/lu";
import "../../components/DashboardModule/MyQuotations.css";
import { cancelBuyerEnquiry, getEnquiries } from "../../API/Api";
import PendingQuotesDetailsBuyer from "./PendingQuotesDetailsBuyer";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const RFQ = () => {
    const [enquiries, setEnquiries] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedEnquiry, setSelectedEnquiry] = useState(null);
    const [showDetails, setShowDetails] = useState(false);
    const [isCancelling, setIsCancelling] = useState(false);

    useEffect(() => {
        const fetchEnquiries = async () => {
            try {
                const data = await getEnquiries();
                setEnquiries(data?.data || []);
            } catch (error) {
                console.error("Error fetching enquiries:", error);
            }
        };

        fetchEnquiries();
    }, []);

    const filteredEnquiries = enquiries.filter((enquiry) => {
        const searchLower = searchTerm.toLowerCase();
        return (
            enquiry.order_id?.toLowerCase().includes(searchLower) ||
            (enquiry.enquiry_items?.some(item =>
                item.product_name?.toLowerCase().includes(searchLower)
            )) ||
            (enquiry.brands?.some(brand =>
                brand.name?.toLowerCase().includes(searchLower)
            ))
        );
    });

    const handleOpenClick = (enquiry) => {
        setSelectedEnquiry(enquiry);
        setShowDetails(true);
    };

    const handleBackClick = () => {
        setShowDetails(false);
    };

    const handleCancelEnquiry = async (enquiryId) => {
        if (isCancelling) return;

        if (!window.confirm("Are you sure you want to cancel this enquiry?")) {
            return;
        }

        setIsCancelling(true);
        try {
            await cancelBuyerEnquiry(enquiryId);
            toast.success("Enquiry cancelled successfully");
            const data = await getEnquiries();
            setEnquiries(data?.data || []);
        } catch (error) {
            console.error("Error cancelling enquiry:", error);
            toast.error(error.response?.data?.message || "Failed to cancel enquiry");
        } finally {
            setIsCancelling(false);
        }
    };

    if (showDetails && selectedEnquiry) {
        return (
            <PendingQuotesDetailsBuyer
                onBack={handleBackClick}
                enquiry={selectedEnquiry}
                enquiryId={selectedEnquiry.enquiry_id}
            />
        );
    }

    return (
        <div className="quo-container font-poppins">
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className="quo-header">
                <h2 className="quo-title">RFQ Sent</h2>
                <div className="quo-actions">
                    <div className="quo-search-container">
                        <LuSearch className="quo-search-icon" />
                        <input
                            type="text"
                            placeholder="Search quotations"
                            className="quo-search font-poppins"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>
            </div>

            <table className="quo-table">
                <thead>
                    <tr>
                        <th>Enquiry No.</th>
                        <th>Suppliers</th>
                        <th>Status</th>
                        <th>Date</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredEnquiries.map((enquiry) => (
                        <tr key={enquiry.enquiry_id}>
                            <td>
                                <div className="enquiry-info">
                                    <div className="order-id">
                                        {enquiry.order_id}
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div className="suppliers-container">
                                    {enquiry.brands?.length > 0 ? (
                                        enquiry.brands.map((brand) => (
                                            <div key={brand.id} className="supplier-name">
                                                {brand.name}
                                            </div>
                                        ))
                                    ) : (
                                        <div className="supplier-name">....</div>
                                    )}
                                </div>
                            </td>
                            <td>{enquiry.status === "Pending" ? "Waiting for Quotation" : enquiry.status}</td>
                            <td>{new Date(enquiry.created_at).toLocaleDateString()}</td>
                            <td>
                                <div className="quo-action-menu">
                                    <MoreVertical />
                                    <div className="quo-dropdown">
                                        <button
                                            className="text-quo font-poppins"
                                            onClick={() => handleOpenClick(enquiry)}
                                        >
                                            Preview
                                        </button>
                                        <button
                                            className="text-quo font-poppins"
                                            onClick={() => handleCancelEnquiry(enquiry.enquiry_id)}
                                            disabled={isCancelling}
                                        >
                                            {isCancelling ? "Cancelling..." : "Cancel"}
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default RFQ;